export default __webpack_public_path__ + "static/media/arrow-down.c21fdf0f.svg";